enum SearchAlgo {
    LINEAR = 'Linear Search',
    BINARY = 'Binary Search',
}

export default SearchAlgo;
